import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  margin-top: 8rem;
  padding: 2.4rem;
  text-align: center;

  ${media.greaterThan('medium')`
    width: 60vw;
  `}
`;

export const Title = styled.p`
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 600;
  margin-bottom: 2.4rem;

  ${media.greaterThan('medium')`
    font-size: 4.8rem;
    line-height: 5.4rem;
  `}
`;
